module.exports = __webpack_public_path__ + "static/img/home02.501a191c.png";